import React from 'react';

function WorkersPage() {
  return (
    <div>
      <h1 className="product-page-title">Workers</h1>
      <p className="product-page-subtitle">Bake workers assigned to your workspace.</p>
      <div className="product-card">
        <p className="mb-0 text-muted">
          Worker management for customer tenants is coming soon. Platform operators can view global
          worker status under the Platform console.
        </p>
      </div>
    </div>
  );
}

export default WorkersPage;
